import { render, staticRenderFns } from "./UsuariosPermisosAplicacion.vue?vue&type=template&id=d8857736&scoped=true&"
import script from "./UsuariosPermisosAplicacion.vue?vue&type=script&lang=js&"
export * from "./UsuariosPermisosAplicacion.vue?vue&type=script&lang=js&"
import style0 from "./UsuariosPermisosAplicacion.vue?vue&type=style&index=0&id=d8857736&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8857736",
  null
  
)

export default component.exports